import { ROUTES } from 'constants/routes';
import React from 'react';
import { useNav } from 'utils/navigation';
import PageBarButton from '../PageBarButton/PageBarButton';

const AuditBarButton: React.FC = () => {
	const nav = useNav();

	return (
		<PageBarButton
			onClick={() => nav(ROUTES.audit)}
			text={intl.tr('general.auditLog')}
			data-testid="audit-bar-button"
		/>
	);
};

export default AuditBarButton;
